export default __webpack_public_path__ + "a802a7f8307cca9183b08661efed28df.png";